export default "__VITE_ASSET__uor_de5r__"